import { nanoid } from 'nanoid';
import { Injectable } from '@angular/core';
@Injectable()
export class LODBHelperService {

	statesVM = {};
	statementsVM = {};
	
	queue = [];
	isTxPending = false;

	async initializeLOVMObject(userId, peCode) {

		this.statesVM = await this.getStatesFromDB(userId, peCode);
		this.statementsVM = await this.getStatementsFromDB(userId, peCode);
	}

	getStatesFromDB(userId, peCode) {
		return DLS_IPCCallers.GET_LO_DATA({ uid: userId, peCode: peCode, userDataType: 'lo_states' });
	}

	getStatementsFromDB(userId, peCode) {
		return DLS_IPCCallers.GET_LO_DATA({ uid: userId, peCode: peCode, userDataType: 'lo_statements' });
	}

	getCurrentStatesVM() {
		return this.statesVM;
	}

	getCurrentStatementsVM() {
		return this.statementsVM;
	}

	fetchFromStatesVM(spaceId, classId, productCode, uniqueLOId) {

		if (!this.statesVM) return;
		if (!this.statesVM[uniqueLOId]) return;

		let statesData = [];
		Object.keys(this.statesVM[uniqueLOId]).forEach(space => {

			if (this.statesVM[uniqueLOId][space].metadata.folderType == 'space') {
				Object.keys(this.statesVM[uniqueLOId][space]).forEach(classs => {

					if (classs == 'metadata') return;
					statesData.push(this.statesVM[uniqueLOId][space][classs]);
				});
			} else {
				statesData.push(this.statesVM[uniqueLOId][space]);
			}
		});


		if (statesData.length) {
			statesData = statesData.sort((a, b) => {
				return b.data.timestamp - a.data.timestamp;
			});
			this.storeInStatesVM(statesData[0].metadata.extUserId, spaceId, classId, productCode, uniqueLOId, statesData[0].data);
			return statesData[0].data;
		}

		// this will be required for context based classes maybe?
		// if (!this.statesVM) return;
		// if (!this.statesVM[uniqueLOId]) return;
		// if (!this.statesVM[uniqueLOId][spaceId]) return;

		// if (classId) {

		// 	if (!this.statesVM[uniqueLOId][spaceId][classId]) return;
		// 	if (!this.statesVM[uniqueLOId][spaceId][classId]) return;
		// 	if (!this.statesVM[uniqueLOId][spaceId][classId]['data']) return;

		// 	return this.statesVM[uniqueLOId][spaceId][classId]['data'];

		// } else {
		// 	if (!this.statesVM[uniqueLOId][spaceId]) return;
		// 	if (!this.statesVM[uniqueLOId][spaceId]['data']) return;

		// 	return this.statesVM[uniqueLOId][spaceId]['data'];
		// }


	}

	async storeInStatesVM(extUserId, spaceId, classId, productCode, uniqueId, stateData) {
		if (!this.statesVM) this.statesVM = {};
		if (!this.statesVM[uniqueId]) this.statesVM[uniqueId] = {};
		if (!this.statesVM[uniqueId][spaceId]) this.statesVM[uniqueId][spaceId] = {
			metadata: {
				folderType: 'space'
			}
		};

		if (classId) {

			if (!this.statesVM[uniqueId][spaceId][classId]) this.statesVM[uniqueId][spaceId][classId] = {
				metadata: {
					folderType: 'class'
				}
			};

			let uniqueStatementId = nanoid(16);
			stateData.uniqueStatementId = uniqueStatementId;
			this.statesVM[uniqueId][spaceId][classId]['data'] = stateData;
			this.statesVM[uniqueId][spaceId][classId]['metadata'] = {
				uniqueId,
				classId,
				spaceId,
				productCode,
				extUserId
			};
		} else {
			let uniqueStatementId = nanoid(16);
			stateData.uniqueStatementId = uniqueStatementId;
			this.statesVM[uniqueId][spaceId]['data'] = stateData;
			this.statesVM[uniqueId][spaceId]['metadata'] = {
				uniqueId,
				classId,
				spaceId,
				productCode,
				extUserId
			};
		}

		await this.putVMinDB(extUserId, productCode, 'lo_states', this.statesVM);
	}

	async storeInStatementsVM(extUserId, spaceId, classId, productCode, uniqueId, statementsData) {
		if (!this.statementsVM) this.statementsVM = {};
		if (!this.statementsVM[uniqueId]) this.statementsVM[uniqueId] = {};
		if (!this.statementsVM[uniqueId][spaceId]) this.statementsVM[uniqueId][spaceId] = {
			metadata: {
				folderType: 'space'
			}
		};

		if (classId) {

			if (!this.statementsVM[uniqueId][spaceId][classId]) this.statementsVM[uniqueId][spaceId][classId] = {
				metadata: {
					folderType: 'class'
				}
			};
			if (!this.statementsVM[uniqueId][spaceId][classId]['data']) this.statementsVM[uniqueId][spaceId][classId]['data'] = [];

			if (Array.isArray(statementsData)) {
				statementsData.forEach(statement => {
					let uniqueStatementId = nanoid(16);
					statement.json.meta.uniqueStatementId = uniqueStatementId;
					this.statementsVM[uniqueId][spaceId][classId]['data'].push(statement);
				});
			} else {
				let uniqueStatementId = nanoid(16);
				statementsData.json.meta.uniqueStatementId = uniqueStatementId;
				this.statementsVM[uniqueId][spaceId][classId]['data'].push(statementsData);
			}

			this.statementsVM[uniqueId][spaceId][classId]['metadata'] = {
				uniqueId,
				classId,
				spaceId,
				productCode,
				extUserId
			};
		} else {
			if (!this.statementsVM[uniqueId][spaceId]['data']) this.statementsVM[uniqueId][spaceId]['data'] = [];


			if (Array.isArray(statementsData)) {
				statementsData.forEach(statement => {
					let uniqueStatementId = nanoid(16);
					statement.json.meta.uniqueStatementId = uniqueStatementId;
					this.statementsVM[uniqueId][spaceId]['data'].push(statement);
				});
			} else {
				let uniqueStatementId = nanoid(16);
				statementsData.json.meta.uniqueStatementId = uniqueStatementId;
				this.statementsVM[uniqueId][spaceId]['data'].push(statementsData);
			}

			this.statementsVM[uniqueId][spaceId]['metadata'] = {
				uniqueId,
				classId,
				spaceId,
				productCode,
				extUserId
			};
		}

		await this.putVMinDB(extUserId, productCode, 'lo_statements', this.statementsVM);
	}

	setCurrentStatesVM(statesObject) {
		this.statesVM = statesObject;
	}

	setCurrentStatementsVM(statementsObject) {
		this.statementsVM = statementsObject;
	}

	resetCurrentStatesVM() {
		this.statesVM = {};
	}

	resetCurrentStatementsVM() {
		this.statementsVM = {};
	}

	async putVMinDB(userId, peCode, userDataType, data, updateVM = false) {

		if (updateVM) {
			this.statementsVM = data;
		}

		// await DLS_IPCCallers.SET_LO_DATA({ uid: userId, peCode: peCode, userDataType: userDataType, data: data });
		this.addDataToQueue({ uid: userId, peCode: peCode, userDataType: userDataType, data: data })
	}

	addDataToQueue(data) {
		this.queue.push(data);
		this.invokeQueue();
	}

	async invokeQueue() {


		if (this.isTxPending) {
			return;
		}

		if (this.queue.length) {
			let data = this.queue.shift();

			console.log('11111 Queue invoked tx pending', this.isTxPending, this.queue.length);

			this.isTxPending = true;
			await DLS_IPCCallers.SET_LO_DATA(data);
			console.log('11111 Queue invoked tx complete', this.isTxPending, this.queue.length);

			this.isTxPending = false;
			this.invokeQueue();
		}

	}


}